import { loadProviders1vax66n493hpl as loadProviders } from './CryptographySystem.nonJvm.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CryptographyProviderwgv0x40nzvjc as CryptographyProvider } from './CryptographyProvider.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  first58ocm7j58k3q as first,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Default_getInstance1zramwb175hhz as Default_getInstance } from '../../../../cryptography-kotlin-cryptography-random/dev/whyoleg/cryptography/random/CryptographyRandom.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CryptographySystemClass;
function CryptographySystem() {
  if (CryptographySystemClass === VOID) {
    class $ {
      constructor() {
        CryptographySystem_instance = this;
        this.impl_1 = new (CryptographySystemImpl())();
        loadProviders(this);
      }
      registerProvider_gzjt6_k$(provider, priority) {
        return this.impl_1.registerProvider_gzjt6_k$(provider, priority);
      }
    }
    initMetadataForObject($, 'CryptographySystem');
    CryptographySystemClass = $;
  }
  return CryptographySystemClass;
}
var CryptographySystem_instance;
function CryptographySystem_getInstance() {
  if (CryptographySystem_instance === VOID)
    new (CryptographySystem())();
  return CryptographySystem_instance;
}
var CompositeProviderClass;
function CompositeProvider() {
  if (CompositeProviderClass === VOID) {
    class $ extends CryptographyProvider() {
      constructor(providers) {
        super();
        this.providers_1 = providers;
      }
    }
    initMetadataForClass($, 'CompositeProvider');
    CompositeProviderClass = $;
  }
  return CompositeProviderClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function CryptographySystemImpl$lazyRegisteredProviders$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.get_key_18j28a_k$();
  var tmp$ret$2 = b.get_key_18j28a_k$();
  return compareValues(tmp, tmp$ret$2);
}
var CryptographySystemImplClass;
function CryptographySystemImpl() {
  if (CryptographySystemImplClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.registeredProviders_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_0 = this;
        tmp_0.lazyRegisteredProviders_1 = lazy(() => {
          // Inline function 'kotlin.collections.sortedBy' call
          var this_0 = this.registeredProviders_1.get_entries_p20ztl_k$();
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = CryptographySystemImpl$lazyRegisteredProviders$lambda$lambda;
          var tmp$ret$2 = new (sam$kotlin_Comparator$0())(tmp);
          // Inline function 'kotlin.collections.map' call
          var this_1 = sortedWith(this_0, tmp$ret$2);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s = this_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$5 = item.get_value_j01efc_k$().get_value_j01efc_k$();
            destination.add_utx5q5_k$(tmp$ret$5);
          }
          return destination;
        });
        this.defaultProvider_1 = null;
        var tmp_1 = this;
        tmp_1.lazyDefaultProvider_1 = lazy(() => {
          var tmp0_elvis_lhs = this.defaultProvider_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.let' call
            var it = this.lazyRegisteredProviders_1.get_value_j01efc_k$();
            var tmp_0;
            switch (it.get_size_woubt6_k$()) {
              case 0:
                // Inline function 'kotlin.error' call

                var message = 'No providers registered. Please provide a dependency or register provider explicitly';
                throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
              case 1:
                tmp_0 = first(it);
                break;
              default:
                tmp_0 = new (CompositeProvider())(it);
                break;
            }
            tmp = tmp_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        this.defaultRandom_1 = null;
        var tmp_2 = this;
        tmp_2.lazyDefaultRandom_1 = lazy(() => {
          var tmp0_elvis_lhs = this.defaultRandom_1;
          return tmp0_elvis_lhs == null ? Default_getInstance() : tmp0_elvis_lhs;
        });
      }
      registerProvider_gzjt6_k$(provider, priority) {
        // Inline function 'kotlin.require' call
        if (!(priority >= 0)) {
          var message = 'Priority must be greater or equal to 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.registeredProviders_1;
        // Inline function 'kotlin.require' call
        if (!!(isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).containsKey_aw81wo_k$(priority)) {
          var message_0 = 'Provider with priority ' + priority + ' already registered. Every registered provider should have unique priority.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        if (!!this.lazyRegisteredProviders_1.isInitialized_2wsk3a_k$()) {
          var message_1 = 'Cannot register provider after `getRegisteredProviders` was called';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_1));
        }
        // Inline function 'kotlin.collections.set' call
        this.registeredProviders_1.put_4fpzoq_k$(priority, provider);
      }
    }
    initMetadataForClass($, 'CryptographySystemImpl', CryptographySystemImpl);
    CryptographySystemImplClass = $;
  }
  return CryptographySystemImplClass;
}
//region block: exports
export {
  CryptographySystem_getInstance as CryptographySystem_getInstance4e2ihcoisse,
};
//endregion

//# sourceMappingURL=CryptographySystem.mjs.map
